import { createSlice } from "@reduxjs/toolkit";

const callApplicationSlice = createSlice({
  name: "callApplication",
  initialState: {
    statusUpdated: false, // Track if status was updated
  },
  reducers: {
    triggerStatusUpdate: (state) => {
      state.statusUpdated = !state.statusUpdated; // Toggle value to force reactivity
    },
  },
});

export const { triggerStatusUpdate } = callApplicationSlice.actions;
export default callApplicationSlice.reducer;
